(() => {
  if (!['/tools/Track-Your-Order', '/apps/17TRACK'].includes(location.pathname)) return;
  let pageObserver, mountObserver, mountTimeout;
  function mount() {
    const root = document.querySelector('.yq-app');
    if (!root || root.dataset.vorugProviderEnhanced) return !!root;
    root.dataset.vorugProviderEnhanced = 'true';
    const modes = [
      { selector: '.yq-track-tab-order-num', form: 'orderForm', id: 'vorug-17track-order-tab' },
      { selector: '.yq-track-tab-tracking-num', form: 'trackingForm', id: 'vorug-17track-number-tab' }
    ];
    function sync() {
      const tabs = modes.map(mode => root.querySelector(mode.selector));
      modes.forEach((mode, index) => {
        const tab = tabs[index], form = root.querySelector('#' + mode.form);
        if (!tab || !form) return;
        tab.id ||= mode.id;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', form.id);
        const active = tab.classList.contains('yq-track-num-active');
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.parentElement.setAttribute('role', 'tablist');
        tab.parentElement.setAttribute('aria-label', 'Tracking method');
        form.setAttribute('role', 'tabpanel');
        form.setAttribute('aria-labelledby', tab.id);
        if (tab.dataset.vorugKeyboardReady) return;
        tab.dataset.vorugKeyboardReady = 'true';
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % modes.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + modes.length) % modes.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = modes.length - 1;
          if (event.key === 'Enter' || event.key === ' ') next = index;
          if (next === undefined) return;
          const target = root.querySelector(modes[next].selector);
          if (!target) return;
          event.preventDefault();
          target.click();
          target.focus();
        });
      });
      [
        { id: 'orderForm_order_no', autocomplete: 'off' },
        { id: 'orderForm_user_email', autocomplete: 'email', inputmode: 'email' },
        { id: 'trackingForm_track_no', autocomplete: 'off' }
      ].forEach(field => {
        const input = root.querySelector('#' + field.id);
        if (!input) return;
        const labelId = field.id + '-vorug-label';
        if (!root.querySelector('#' + labelId)) {
          const label = document.createElement('label');
          label.id = labelId;
          label.htmlFor = input.id;
          label.className = 'vorug-tracking-label';
          label.textContent = input.getAttribute('aria-label') || input.placeholder;
          input.before(label);
        }
        input.setAttribute('autocomplete', field.autocomplete);
        if (field.inputmode) input.setAttribute('inputmode', field.inputmode);
      });
    }
    let queued = false;
    pageObserver = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; sync(); });
    });
    pageObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    sync();
    return true;
  }
  function start() {
    if (mount()) return;
    mountObserver = new MutationObserver(() => {
      if (mount()) { mountObserver.disconnect(); clearTimeout(mountTimeout); }
    });
    mountObserver.observe(document.body, { childList: true, subtree: true });
    mountTimeout = setTimeout(() => mountObserver.disconnect(), 10000);
  }
  const afterProviderLoad = () => requestAnimationFrame(() => requestAnimationFrame(start));
  if (document.readyState === 'complete') afterProviderLoad();
  else window.addEventListener('load', afterProviderLoad, { once: true });
  window.addEventListener('pagehide', event => {
    if (event.persisted) return;
    pageObserver?.disconnect();
    mountObserver?.disconnect();
    clearTimeout(mountTimeout);
  });
})();
